import request from '../../request/index'
import sevice from '@/sevice/index'
let api = {
    currlist:()=>{
        return request.get(sevice.currlist)
    }
}
export default  api 